/**
 * Waiting shapes for dashboard cards: grey blocks in the shape of what is coming (list rows, chart bars, number
 * tiles), so the card keeps its size and nothing jumps when the data arrives. They appear only after 150 ms (a fast
 * answer shows no flash), and one band of light passes over every waiting block on the page together. With
 * animations turned off on the device they stay as a still tint. Screen readers hear the label once.
 */
const LIST_WIDTHS = [78, 62, 70, 54, 66];
const BAR_WIDTHS = [92, 74, 58, 41, 27];

export function Skeleton({ shape, rows = 5, label = 'Loading…' }: { shape: 'list' | 'bars' | 'tiles'; rows?: number; label?: string }) {
  const n = Array.from({ length: rows }, (_, i) => i);
  return (
    <div className={`skel skel-${shape}`} role="status" aria-live="polite">
      <span className="sr-only">{label}</span>
      {shape === 'list' && n.map((i) => (
        <div key={i} className="skel-row" aria-hidden="true">
          <i style={{ width: `${LIST_WIDTHS[i % LIST_WIDTHS.length]}%` }} />
          <i className="skel-meta" style={{ width: `${30 + ((i * 17) % 22)}%` }} />
        </div>
      ))}
      {shape === 'bars' && n.map((i) => (
        <div key={i} className="skel-bar-row" aria-hidden="true">
          <i className="skel-label" />
          <i style={{ width: `${BAR_WIDTHS[i % BAR_WIDTHS.length]}%` }} />
        </div>
      ))}
      {shape === 'tiles' && n.map((i) => (
        <div key={i} className="skel-tile" aria-hidden="true">
          <i className="skel-label" />
          <i className="skel-value" />
          <i className="skel-meta" />
        </div>
      ))}
    </div>
  );
}
